import React from "react";
import {css, Theme} from "@emotion/react";

import {calculateRemSize, display, listUnStyled, m, onDesktop, p, pb, underline, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {SiteMapBox} from "./SiteMapBox";

interface ISiteMapRecord {
    href: string;
    header?: string;
    text: string;
}
interface IProps {
    records: ISiteMapRecord[];
    target?: "_self" | "_blank";
    className?: string;
}

export const SiteMapBoxList = (props: IProps) => {
    return (
        <ul css={[listWrapperStyle]} className={props.className}>
            {props.records.map((record) => (
                <SiteMapBox as="li" key={`${record.href}_${record.text}`} css={[p(0)]}>
                    <a href={record.href} css={[linkStyle]} target={props.target}>
                        <Text as="div" variant="body_copy_2" strong css={[pb(2)]}>
                            {record.header}
                        </Text>
                        {record.text}
                    </a>
                </SiteMapBox>
            ))}
        </ul>
    );
};

const listWrapperStyle = css`
    ${listUnStyled};
    ${m(0)};
    display: grid;
    gap: ${calculateRemSize(2)};

    ${onDesktop(css`
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto;
    `)};
`;

const linkStyle = (theme: Theme) => css`
    ${p(3)};
    ${display("inline-block")};
    ${w100};

    &:hover,
    &:focus,
    &:active {
        color: ${theme.colors.secondary};
        ${underline};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {calculateRemSize, display, listUnStyled, m, onDesktop, p, pb, underline, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {SiteMapBox} from "./SiteMapBox";

interface ISiteMapRecord {
    href: string;
    header?: string;
    text: string;
}
interface IProps {
    records: ISiteMapRecord[];
    target?: "_self" | "_blank";
    className?: string;
}

export const SiteMapBoxList = (props: IProps) => {
    return (
        <ul css={[listWrapperStyle]} className={props.className}>
            {props.records.map((record) => (
                <SiteMapBox as="li" key={`${record.href}_${record.text}`} css={[p(0)]}>
                    <a href={record.href} css={[linkStyle]} target={props.target}>
                        <Text as="div" variant="body_copy_2" strong css={[pb(2)]}>
                            {record.header}
                        </Text>
                        {record.text}
                    </a>
                </SiteMapBox>
            ))}
        </ul>
    );
};

const listWrapperStyle = css`
    ${listUnStyled};
    ${m(0)};
    display: grid;
    gap: ${calculateRemSize(2)};

    ${onDesktop(css`
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto;
    `)};
`;

const linkStyle = (theme: Theme) => css`
    ${p(3)};
    ${display("inline-block")};
    ${w100};

    &:hover,
    &:focus,
    &:active {
        color: ${theme.colors.secondary};
        ${underline};
    }
`;
